import { render } from "./NbShowerheadsRenderer.vue?vue&type=template&id=689d3731&scoped=true"
import script from "./NbShowerheadsRenderer.vue?vue&type=script&lang=js"
export * from "./NbShowerheadsRenderer.vue?vue&type=script&lang=js"

import "./NbShowerheadsRenderer.vue?vue&type=style&index=0&id=689d3731&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689d3731"]])

export default __exports__